var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 87.5,
    fill: "white",
    stroke: "white",
    strokeWidth: 5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 82.5,
    stroke: "#3889FA",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.537 123.333C115.788 111.257 104.342 101.712 90 101.712C75.6582 101.712 64.2116 111.257 61.4633 123.333H118.537ZM96.5422 85.4953C103.993 82.8386 109.319 75.7737 109.319 67.4771C109.319 56.9019 100.67 48.3333 90 48.3333C79.3295 48.3333 70.6806 56.9019 70.6806 67.4771C70.6806 75.7737 76.0074 82.8386 83.4578 85.4953C85.5009 86.2238 87.7036 86.6208 90 86.6208C92.2964 86.6208 94.4991 86.2238 96.5422 85.4953ZM97.1444 94.0265C114.417 97.198 127.5 111.644 127.5 128.931C127.5 130.442 126.21 131.667 124.616 131.667H55.3841C53.7904 131.667 52.5 130.442 52.5 128.931C52.5 111.644 65.5833 97.198 82.8556 94.0265C85.169 93.6017 87.5576 93.3792 90 93.3792C92.4424 93.3792 94.831 93.6017 97.1444 94.0265ZM100.986 67.4771C100.986 61.5764 96.1405 56.6666 90 56.6666C83.8595 56.6666 79.0139 61.5764 79.0139 67.4771C79.0139 73.3754 83.8604 78.2875 90 78.2875C96.1396 78.2875 100.986 73.3754 100.986 67.4771Z",
    fill: "#3889FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.ac77c658.svg";
export { ForwardRef as ReactComponent };